import React from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
// import { Polytechnics } from "../../../utils/polytechnics"; // Polytechnic choice removed - Maduka-only portal
import { Universities } from "../../../utils/univerisities";
import {
  addJambFirstChoice,
  addJambNumber,
  addJambSecondChoice,
  addJambSubjectScore,
  addTotalScore,
  appliedFirstJoice,
  appliedSecondJoice,
} from "../../../redux/reducers/features/applicant-data/jamb-info-slice";

import { validateJambScore, validateJambNumber } from '../../../utils/validateDataEntry';
import { JAMB_SUBJECTS } from "../../../data";
import { excludeSelectedOptions } from "../../../utils/selectExclusion";

export default function JambInformation({ onForwardClick, onPreviousClick, departments, faculty }) {
  const dispatch = useDispatch();

  const [jambNumber, setJambNumber] = React.useState(""); //required
  const [jambTotalScore, setJambTotalScore] = React.useState(""); //required
  const [jambScoreOne, setJambScoreOne] = React.useState("");
  const [jambScoreTwo, setJambScoreTwo] = React.useState("");
  const [jambScoreThree, setJambScoreThree] = React.useState("");
  const [jambScoreFour, setJambScoreFour] = React.useState("");
  const [jambSubjectOne, setJambSubjectOne] = React.useState("English Language");
  const [jambSubjectTwo, setJambSubjectTwo] = React.useState("");
  const [jambSubjectThree, setJambSubjectThree] = React.useState("");
  const [jambSubjectFour, setJambSubjectFour] = React.useState("");
  const [firstChoiceUni] = React.useState(Universities?.[0]?.name || "Maduka University");
  // const [firstChoicePoly, setFirstChoicePoly] = React.useState(""); // Polytechnic choice removed - Maduka-only portal
  const [firstChoiceCourse, setFirstChoiceCourse] = React.useState("");
  const [secondChoiceUni] = React.useState(Universities?.[0]?.name || "Maduka University");
  // const [secondChoicePoly, setSecondChoicePoly] = React.useState(""); // Polytechnic choice removed - Maduka-only portal
  const [secondChoiceCourse, setSecondChoiceCourse] = React.useState("");
  // const [firstFaculty, setFirstFaculty] = React.useState(""); // Faculty removed
  const [firstDepartment, setFirstDepartment] = React.useState("");
  const [firstDepartments, setFirstDepartments] = React.useState([]);
  // const [secondFaculty, setSecondFaculty] = React.useState(""); // Faculty removed
  const [secondDepartment, setSecondDepartment] = React.useState("");
  const [secondDepartments, setSecondDepartments] = React.useState([]);

  // console.log("Faculties gotten:", faculty); // Faculty removed

  const handleForwardClick = () => {

    if (!validateJambScore(jambTotalScore, jambScoreOne, jambScoreTwo, jambScoreThree, jambScoreFour)) {
      toast.error('Jamb individual scores must be equal to the entered total score');
      return
    }

    if (jambNumber && !validateJambNumber(jambNumber)) {
      toast.error('JAMB Number must be 12 digits followed by 2 letters');
      return
    }

    if (
      jambNumber &&
      jambTotalScore &&
      firstChoiceUni &&
      // firstChoicePoly && // Polytechnic removed
      firstChoiceCourse &&
      secondChoiceUni &&
      // secondChoicePoly && // Polytechnic removed
      secondChoiceCourse &&
      firstDepartment &&
      // firstFaculty && // Faculty removed
      secondDepartment &&
      // secondFaculty && // Faculty removed
      jambSubjectOne &&
      jambScoreOne &&
      jambSubjectTwo &&
      jambScoreTwo &&
      jambSubjectThree &&
      jambScoreThree &&
      jambSubjectFour &&
      jambScoreFour
    ) {
      let data = {
        jamb_number: jambNumber,
        jamb_total_score: jambTotalScore,
        jamb_subject_scores: [
          { subject: jambSubjectOne, score: jambScoreOne },
          { subject: jambSubjectTwo, score: jambScoreTwo },
          { subject: jambSubjectThree, score: jambScoreThree },
          { subject: jambSubjectFour, score: jambScoreFour },
        ],
        jamb_first_choice: {
          university: firstChoiceUni,
          // polytechnic: firstChoicePoly, // Polytechnic removed
          course: firstChoiceCourse,
        },
        jamb_second_choice: {
          university: secondChoiceUni,
          // polytechnic: secondChoicePoly, // Polytechnic removed
          course: secondChoiceCourse,
        },
        applied_first_choice: {
          department: firstDepartment,
          // faculty: firstFaculty, // Faculty removed
        },
        applied_second_choice: {
          department: secondDepartment,
          // faculty: secondFaculty, // Faculty removed
        },
      };

      onForwardClick(data);

      dispatch(appliedSecondJoice(data.applied_second_choice));
      dispatch(appliedFirstJoice(data.applied_first_choice));
      dispatch(addTotalScore(data.jamb_total_score));
      dispatch(addJambSubjectScore(data.jamb_subject_scores));
      dispatch(addJambFirstChoice(data.jamb_first_choice));
      dispatch(addJambSecondChoice(data.jamb_second_choice));
      dispatch(addJambNumber(data.jamb_total_score));
    } else {
      toast.error("ensure all required fields are filled");
    }
  };

  React.useEffect(() => {
    // Faculty removed - departments were previously filtered by selected faculty:
    // (() => {
    //   console.log("firstFaculty", firstFaculty);
    //   let filteredDepartments = departments?.filter(
    //     (item) => item?.faculty?._id === firstFaculty?._id
    //   );
    //   if (filteredDepartments) {
    //     setFirstDepartments(filteredDepartments);
    //   } else {
    //     setFirstDepartments([]);
    //   }
    // })();
    setFirstDepartments(departments || []);

    // (() => {
    //   let filteredDepartments = departments?.filter(
    //     (item) => item?.faculty?._id === secondFaculty
    //   );
    //   if (filteredDepartments) {
    //     setSecondDepartments(filteredDepartments);
    //   } else {
    //     setSecondDepartments([]);
    //   }
    // })()
    setSecondDepartments(departments || []);

  }, [departments, firstDepartment, secondDepartment]);


  const checkJambScore = (event, sourceType) => {

    switch (sourceType) {
      case 'totalScore':
        setJambTotalScore(event.target.value);
        break;
      case 'firstScore':
        setJambScoreOne(event.target.value);
        break;
      case 'secondScore':
        setJambScoreTwo(event.target.value);
        break;
      case 'thirdScore':
        setJambScoreThree(event.target.value);
        break;
      case 'fourthScore':
        setJambScoreFour(event.target.value);
        break;
      default:
        break;
    }

  }

  return (
    <Card sx={{ p: { xs: 0, lg: 3 }, mt: { xs: 1.8, lg: 3 } }}>
      <CardContent>
        <Typography
          variant="h6"
          component="h6"
          color="#00356B"
          sx={{ fontStyle: 'italic', margin: '1rem 0', fontSize: '25px', lineHeight: '30px', fontWeight: '500' }}
        >
          JAMB Details
        </Typography>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="JAMB Number"
                placeholder="Enter JAMB Number"
                variant="outlined"
                value={jambNumber}
                onChange={(e) => setJambNumber(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                type={"number"}
                label="JAMB Score"
                placeholder="Select Score"
                variant="outlined"
                value={jambTotalScore}
                onChange={(e) => checkJambScore(e, 'totalScore')}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Typography variant="body1" className="fw-bold mt-4 mb-3">
          JAMB Subjects and Scores
        </Typography>

        <Grid container spacing={2} sx={{ mt: -1.0 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ minWidth: "100%" }}>
              <InputLabel id="demo-simple-select-autowidth-label">
                Select Subject
              </InputLabel>
              <Select
                value={jambSubjectOne}
                onChange={(e) => setJambSubjectOne(e.target.value)}
                fullWidth
                disabled
                label="Select Subject"
              >
                {JAMB_SUBJECTS?.map((subject, index) => (
                  <MenuItem value={subject} key={Math.random() + "-" + index}>
                    {subject}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                type={"number"}
                label="Subject Score"
                placeholder="Subject Score"
                variant="outlined"
                value={jambScoreOne}
                onChange={(e) => checkJambScore(e, 'firstScore')}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 3.0 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ minWidth: "100%" }}>
              <InputLabel id="demo-simple-select-autowidth-label">
                Select Subject
              </InputLabel>
              <Select
                value={jambSubjectTwo}
                onChange={(e) => {
                  const value = e.target.value;
                  setJambSubjectTwo(value);
                  if (jambSubjectThree === value) setJambSubjectThree("");
                  if (jambSubjectFour === value) setJambSubjectFour("");
                }}
                fullWidth
                label="Select Subject"
              >
                {excludeSelectedOptions(JAMB_SUBJECTS, jambSubjectTwo, [jambSubjectOne, jambSubjectThree, jambSubjectFour])?.map((subject, index) => (
                  <MenuItem value={subject} key={Math.random() + "-" + index}>
                    {subject}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                type={"number"}
                label="Subject Score"
                placeholder="Subject Score"
                variant="outlined"
                value={jambScoreTwo}
                onChange={(e) => checkJambScore(e, 'secondScore')}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 3.0 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ minWidth: "100%" }}>
              <InputLabel id="demo-simple-select-autowidth-label">
                Select Subject
              </InputLabel>
              <Select
                value={jambSubjectThree}
                onChange={(e) => {
                  const value = e.target.value;
                  setJambSubjectThree(value);
                  if (jambSubjectTwo === value) setJambSubjectTwo("");
                  if (jambSubjectFour === value) setJambSubjectFour("");
                }}
                fullWidth
                label="Select Subject"
              >
                {excludeSelectedOptions(JAMB_SUBJECTS, jambSubjectThree, [jambSubjectOne, jambSubjectTwo, jambSubjectFour])?.map((subject, index) => (
                  <MenuItem value={subject} key={Math.random() + "-" + index}>
                    {subject}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                type={"number"}
                label="Subject Score"
                placeholder="Subject Score"
                variant="outlined"
                value={jambScoreThree}
                onChange={(e) => checkJambScore(e, 'thirdScore')}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 3.0 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ minWidth: "100%" }}>
              <InputLabel id="demo-simple-select-autowidth-label">
                Select Subject
              </InputLabel>
              <Select
                value={jambSubjectFour}
                onChange={(e) => {
                  const value = e.target.value;
                  setJambSubjectFour(value);
                  if (jambSubjectTwo === value) setJambSubjectTwo("");
                  if (jambSubjectThree === value) setJambSubjectThree("");
                }}
                fullWidth
                label="Select Subject"
              >
                {excludeSelectedOptions(JAMB_SUBJECTS, jambSubjectFour, [jambSubjectOne, jambSubjectTwo, jambSubjectThree])?.map((subject, index) => (
                  <MenuItem value={subject} key={Math.random() + "-" + index}>
                    {subject}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                type={"number"}
                label="Subject Score"
                placeholder="Subject Score"
                variant="outlined"
                value={jambScoreFour}
                onChange={(e) => checkJambScore(e, 'fourthScore')}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Typography variant="body1" className="fw-bold mt-4 mb-3">
          Institutions of choices as stated in your JAMB UTME application form
        </Typography>

        <Grid container spacing={2} sx={{ mt: -1.0 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                label="First Choice University"
                variant="outlined"
                value={firstChoiceUni}
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                label="Second Choice University"
                variant="outlined"
                value={secondChoiceUni}
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Grid>
          {/* Polytechnic choice removed - Maduka-only portal
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ marginTop: "", minWidth: "100%" }}>
              <InputLabel>Select First Choice Polytechnic</InputLabel>
              <Select
                value={firstChoicePoly}
                onChange={(e) => setFirstChoicePoly(e.target.value)}
                fullWidth
                label="Select First Choice University"
              >
                {Polytechnics?.map((item, index) => (
                  <MenuItem value={item.name} key={index}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ marginTop: "", minWidth: "100%" }}>
              <InputLabel>Select Second Choice Polytechnic</InputLabel>
              <Select
                value={secondChoicePoly}
                onChange={(e) => setSecondChoicePoly(e.target.value)}
                fullWidth
                label="Select Second Choice University"
              >
                {Polytechnics?.map((item, index) => (
                  <MenuItem value={item.name} key={index}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          */}

        </Grid>
        <Grid container spacing={2} sx={{ mt: 3 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                label="First Choice Course"
                placeholder="Enter First Choice Course"
                variant="outlined"
                value={firstChoiceCourse}
                onChange={(e) => setFirstChoiceCourse(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                label="Second Choice Course"
                placeholder="Enter Second Choice Course"
                variant="outlined"
                value={secondChoiceCourse}
                onChange={(e) => setSecondChoiceCourse(e.target.value)}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Typography variant="body1" className="fw-bold mt-4 mb-3">
          Desired Department at Maduka University, Enugu
        </Typography>
        {/* Original heading: "Desired Department and Faculty at Maduka University, Enugu" - Faculty removed */}

        <Grid container spacing={2} sx={{ mt: -1.5 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 1, minWidth: "100%" }}>
              <InputLabel>Select First Choice Department</InputLabel>
              <Select
                value={firstDepartment}
                onChange={(e) => {
                  const value = e.target.value;
                  setFirstDepartment(value);
                  if (secondDepartment === value) setSecondDepartment("");
                }}
                fullWidth
                label="First Choice Department"
              >
                {excludeSelectedOptions(firstDepartments, firstDepartment, [secondDepartment], (row) => row._id)?.map((row, index) => (
                  <MenuItem value={row._id} key={Math.random() + "-" + index}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 1, minWidth: "100%" }}>
              <InputLabel>Select Second Choice Department</InputLabel>
              <Select
                value={secondDepartment}
                onChange={(e) => {
                  const value = e.target.value;
                  setSecondDepartment(value);
                  if (firstDepartment === value) setFirstDepartment("");
                }}
                fullWidth
                label="Second Choice Department"
              >
                {excludeSelectedOptions(secondDepartments, secondDepartment, [firstDepartment], (row) => row._id)?.map((row, index) => (
                  <MenuItem value={row._id} key={index}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* Faculty removed
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 1, minWidth: "100%" }}>
              <InputLabel>Select First Choice Faculty</InputLabel>
              <Select
                value={firstFaculty}
                onChange={(e) => setFirstFaculty(e.target.value)}
                fullWidth
                label="First Choice Faculty"
              >
                {faculty?.map((row, index) => (
                  <MenuItem value={row} key={index}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 1, minWidth: "100%" }}>
              <InputLabel>Select Second Choice Faculty</InputLabel>
              <Select
                value={secondFaculty}
                onChange={(e) => setSecondFaculty(e.target.value)}
                fullWidth
                label="Second Choice Faculty"
              >
                {faculty?.map((row, index) => (
                  <MenuItem value={row._id} key={Math.random() + "-" + index}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          */}
        </Grid>
      </CardContent>

      <CardActions>
        <Grid container spacing={2} className="px-2 w-100">
          <Grid size={{ xs: 12, md: 6 }}>
            <Button
              variant="outlined"
              color="tertiary"
              onClick={onPreviousClick}
              sx={{
                py: 1.5,
                mt: 2,
                textTransform: "uppercase",
                borderRadius: 2,
                color: "#000",
                width: '100%'
              }}
            >
              Previous
            </Button>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Button
              variant="contained"
              onClick={handleForwardClick}
              sx={{
                py: 1.5,
                mt: 2,
                textTransform: "uppercase",
                borderRadius: 2,
                color: "#fff",
                width: '100%'
              }}
            >
              Next
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}
